class ProductGallery extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      thumbnailsContainer: '[js-gallery-thumbnails]',
      thumbnail: '[js-gallery-thumbnail-slide]',
      mainCarousel: '[js-gallery-main]',
      mainCarouselWrapper: '[js-gallery-main-wrapper]',
      nextSlideBtn: '[js-gallery-next-btn]',
      prevSlideBtn: '[js-gallery-prev-btn]'
    }

    this.thumbnails = this.querySelectorAll(this._selectors.thumbnail)
    this.mainCarousel = this.querySelector(this._selectors.mainCarousel)
    this.mainCarouselWrapper = this.querySelector(this._selectors.mainCarouselWrapper)

    this.nextSlideBtn = this.querySelector(this._selectors.nextSlideBtn)
    this.prevSlideBtn = this.querySelector(this._selectors.prevSlideBtn)
    this.thumbnailsContainer = this.querySelector(this._selectors.thumbnailsContainer)
    this.currentSlide = 0

    // Custom Carousel Logic due to buggy vertical sliders
    this.isDragging = false;
    this.hasMoved = false;
    this.startPos = 0;
    this.scrollStartPos = 0;
    this.boundHandleMouseMove = this.handleMouseMove.bind(this);

    // Logic to distinguish between mobile vs desktop thumbnail layout
    // Determines which direction to scroll the thumbnails in
    const isWideScreen = window.innerWidth > 1279;

    this.thumbnailDirection = {
      offset: isWideScreen ? "offsetTop" : "offsetLeft",
      scrollAxis: isWideScreen ? "scrollTop" : "scrollLeft",
      scrollDimensions: isWideScreen ? "scrollHeight" : "scrollWidth",
      page: isWideScreen ? "pageY" : "pageX",
      direction: isWideScreen ? "top" : "left",
    }

    window.addEventListener("resize", () => {
      const isWideScreen = window.innerWidth > 1279;

      this.thumbnailDirection = {
        offset: isWideScreen ? "offsetTop" : "offsetLeft",
        scrollAxis: isWideScreen ? "scrollTop" : "scrollLeft",
        scrollDimensions: isWideScreen ? "scrollHeight" : "scrollWidth",
        page: isWideScreen ? "pageY" : "pageX",
        direction: isWideScreen ? "top" : "left",
      }
    });

  }

  connectedCallback() {

    this.mainCarousel.swiper.on('slideChange', (evt) => {
      const { activeIndex } = evt

      if (activeIndex !== this.selectedIndex) {
        this.selectSlide(activeIndex)
      }

      // if (activeIndex === slideLimit) {
      //   this.mainCarouselWrapper.classList.add('slider-end-reached')
      // } else if (this.mainCarouselWrapper.classList.contains('slider-end-reached')) {
      //   this.mainCarouselWrapper.classList.remove('slider-end-reached')
      // }

    })

    this.nextSlideBtn.addEventListener('click', () => {
      this.mainCarousel.swiper.slideNext()
    })

    this.prevSlideBtn.addEventListener('click', () => {
      this.mainCarousel.swiper.slidePrev()
    })

    this.initDragOrClick()

  }

  selectSlide(selectedIndex, setMainCarousel = false) {
    this.currentSlide = selectedIndex

    this.thumbnails.forEach((thumbnail) => {
      if (thumbnail !== this.thumbnails[selectedIndex] && thumbnail.classList.contains('selected')) {
        thumbnail.classList.remove('selected')
      } else if (thumbnail === this.thumbnails[selectedIndex] && !thumbnail.classList.contains('selected')) {
        thumbnail.classList.add('selected')
      }
    })

    if (setMainCarousel) {
      this.mainCarousel.swiper.slideTo(selectedIndex)
    }

    const selectedSlide = this.thumbnails[selectedIndex]

    if (selectedSlide.getAttribute('data-magic360') === 'true') {
      this.scrollToLastThumbnail()
    } else {
      this.scrollToActiveThumbnail()
    }

    this.checkNavState(selectedIndex)
  }

  checkNavState(selectedIndex) {
    if (selectedIndex == this.thumbnails.length - 1) {
      this.nextSlideBtn.setAttribute('disabled', true)
    } else if (this.nextSlideBtn.getAttribute('disabled') == 'true') {
      this.nextSlideBtn.removeAttribute('disabled')
    }

    if (selectedIndex >= 1 && this.prevSlideBtn.getAttribute('disabled') == 'true') {
      this.prevSlideBtn.removeAttribute('disabled')
    } else if (selectedIndex == 0) {
      this.prevSlideBtn.setAttribute('disabled', true)
    }
  }

  observeActiveThumbnail() {
    // Observer setup to auto-scroll to the active thumbnail
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          this.scrollToActiveThumbnail()
        }
      })
    })

    this.thumbnails.forEach((thumbnail) => {
      observer.observe(thumbnail, {
        attributes: true, // Listen for attribute changes
        attributeFilter: ['class'], // Specifically for class changes
      })
    })
  }

  scrollToLastThumbnail() {
    this.thumbnailsContainer.scrollTo({
      [this.thumbnailDirection.direction]: this.thumbnailsContainer[this.thumbnailDirection.scrollDimensions],
      behavior: 'smooth',
    });
  }

  scrollToActiveThumbnail() {
    const activeThumbnail = this.querySelector(`${this._selectors.thumbnail}.selected`)

    if (activeThumbnail) {
      this.thumbnailsContainer.scrollTo({
        [this.thumbnailDirection.direction]: activeThumbnail[this.thumbnailDirection.offset] - this.thumbnailsContainer[this.thumbnailDirection.offset],
        behavior: 'smooth',
      })
    }
  }

  initDragOrClick() {

    this.thumbnailsContainer.addEventListener('mousedown', (e) => {
      e.preventDefault(); // Prevent default action to avoid dragging images or selecting text
      this.isDragging = false; // Assume it's not dragging initially
      this.hasMoved = false; // Reset moved state
      this.startPos = e[this.thumbnailDirection.page];
      this.scrollStartPos = this.thumbnailsContainer[this.thumbnailDirection.scrollAxis];
      document.addEventListener('mousemove', this.boundHandleMouseMove);
    });

    document.addEventListener('mouseup', (e) => {
      document.removeEventListener('mousemove', this.boundHandleMouseMove);
      this.isDragging && e.preventDefault(); // Prevent click event if it was a drag
      this.isDragging = false;
    });

    this.thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', (e) => {
        !this.hasMoved ? this.handleClick(thumbnail) : e.stopImmediatePropagation();
      });
    });

  }

  handleMouseMove(e) {
    if (Math.abs(e[this.thumbnailDirection.page] - this.startPos) > 5 && !this.isDragging) {
      this.isDragging = true;
      this.thumbnailsContainer.style.userSelect = 'none';
      this.thumbnailsContainer.style.cursor = 'grabbing';
    }
    if (this.isDragging) {
      this.hasMoved = true; // Flag as moved for click handler check
      this.thumbnailsContainer[this.thumbnailDirection.scrollAxis] = this.scrollStartPos - (e[this.thumbnailDirection.page] - this.startPos);
    }
  }

  handleClick(thumbnail) {
    const selectedIndex = Number(thumbnail.getAttribute('data-index'));
    this.selectSlide(selectedIndex, true);
  }



}

if (!customElements.get('product-gallery')) {
  customElements.define("product-gallery", ProductGallery);
}